import * as z from 'zod';

const subsidies_type = ['full', 'partial'] as const;

const subsidiesTypeValues = z.enum(subsidies_type);

export const subsidiesTypeQuerySchema = subsidiesTypeValues.nullable();
type SubsidiesTypeQuerySchema = z.infer<typeof subsidiesTypeQuerySchema>;
export type SubsidiesTypeMutationSchema = z.infer<typeof subsidiesTypeQuerySchema>;

export const subsidiesTypeOptions: SubsidiesTypeFormSchema[] = [
  { name: 'Partially Subsidized', value: 'partial' },
  { name: 'Fully Subsidized', value: 'full' },
];

export const subsidiesTypeFormSchema = z.object({
  name: z.string(),
  value: subsidiesTypeValues,
});

type SubsidiesTypeFormSchema = z.infer<typeof subsidiesTypeFormSchema>;

export const defaultSubsidiesType: SubsidiesTypeFormSchema = subsidiesTypeOptions[0];

export function subsidiesTypeToStr(p?: SubsidiesTypeFormSchema | null) {
  if (p?.value === null || typeof p?.value === 'undefined') {
    return null;
  }
  return p.value;
}

export function strToSubsidiesType(p: SubsidiesTypeQuerySchema): SubsidiesTypeFormSchema | null {
  return subsidiesTypeOptions.find((o) => o.value === p) || subsidiesTypeOptions[0];
}
